import { apiClient } from '../client'
import type { OptionsType } from '../../app/modules/types/filters'
import type { WafAssessmentDetail, WafListResponse } from '../../app/modules/types/waf'
import { OWNS_ERRORS } from '../ownsErrors'

/**
 * WAF assessments — read-only. `api:waf_assessment:view` is a separate scope that
 * the Free plan lacks, so a 403 is an ordinary answer, not an incident: every call
 * is marked `OWNS_ERRORS` so the page renders its own "no access" / "not found"
 * state instead of a toast and a forbidden redirect.
 */
export const wafApi = {
  getList: async (params?: string): Promise<WafListResponse> => {
    const url = params ? `/waf-assessments/?${params}` : '/waf-assessments/'
    const { data } = await apiClient.get(url, OWNS_ERRORS)
    return data
  },

  getById: async (id: string): Promise<WafAssessmentDetail> => {
    const { data } = await apiClient.get(`/waf-assessments/${id}/`, OWNS_ERRORS)
    return data
  },

  /** Facet options, computed over ALL of the organization's assessments. */
  getFilterOptions: async (): Promise<NonNullable<OptionsType>> => {
    const { data } = await apiClient.get('/waf-assessments/filter/', OWNS_ERRORS)
    if (!data || typeof data !== 'object') return {}
    // Drop null-named options at the boundary; non-array entries pass through untouched.
    const sanitized: Record<string, unknown> = {}
    for (const [category, value] of Object.entries(data)) {
      sanitized[category] = Array.isArray(value) ? value.filter((item) => item?.name != null) : value
    }
    return sanitized as NonNullable<OptionsType>
  },
}
